// Signal emitted after any successful add/update/delete so other components
// (or the section itself) can trigger a refetch. Same pattern as the other
// v2 sections' events.js files.
export const HOSP_V2_REFRESH = "hosp-v2:refresh";

// Content -> editor rail: open a blank "Add hospitalisation" form.
export const HOSP_V2_ADD = "hosp-v2:add";

// Content -> editor rail: open THAT entry in the rail, prefilled for update
// (row cause / status chip click). Payload `{ hospitalisation }`; a bare
// payload falls back to a blank add, same contract as LI_V2_EDIT. The rail
// owns both flows — there is no update dialog any more.
export const HOSP_V2_EDIT = "hosp-v2:edit";

// Transcript-mode re-edit of an already-staged captured item. Payload
// `{ captured, hospv2Record }` — hospv2Record is null for a staged-
// add row. Mirrors CC_V2_EDIT_CAPTURED / DX_V2_EDIT_CAPTURED.
export const HOSP_V2_EDIT_CAPTURED = "hosp-v2:edit-captured";
